import { render, staticRenderFns } from "./ServiceCollapse.vue?vue&type=template&id=7a28729a&"
import script from "./ServiceCollapse.vue?vue&type=script&lang=js&"
export * from "./ServiceCollapse.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports